import {
    Component, Input, Optional
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
    selector: 'app-pop-up-card',
    templateUrl: './pop-up-card.component.html',
    styleUrls: ['./pop-up-card.component.scss']
})
export class PopUpCardComponent {
    selectedTab = 0;
    @Input() tabs: any[];
    isFullScreen = false;

    constructor(@Optional() private dialog: MatDialog) { }

    openInFullScreen(activeTab?: number) {
        const component = this.dialog.open(PopUpCardComponent, {
            width: '100%',
            height: '100%',
            panelClass: 'fullscreen'
        });
        component.componentInstance.tabs = this.tabs;
        component.componentInstance.isFullScreen = true;
        component.componentInstance.selectedTab = this.selectedTab;
    }

}
